import React from 'react'

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react'
import TagCustom from '../ServicesDemand/tag'
export default function ItemMatch({
  name = '',
  tel = '',
  skill = '',
  district = '',
  town = '',
  lang = '',
  country='',
  some_document = '',
}) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <div>
      <div>
        <div className=" border user_itembis p-2   my-3 flex-col">
          <h3 className="text-center font-bold text-sm text-green-500">
            Details du profil
          </h3>

          <div className="flex p-2 flex-wra justify-content-center text-center align-item-center align-content-center">
            <div className="text-xs text-muted p-2 w-50">
              <TagCustom size={'md'} price="Personnalite" colorScheme="blue" />
              <div className="flex-col my-1">
                <h6>Nom :</h6>
                <p className="font-bold text-black">{name}</p>
              </div>
              <div className="flex-col my-1 ">
                <h6>Tel :</h6>
                <p className="font-bold text-black">{tel}</p>
              </div>
              <div className="flex-col  my-1 ">
                <h6>Competence :</h6>
                <p className="font-bold text-black">{skill}</p>
              </div>{' '}
            </div>{' '}
            <div className="text-xs text-muted p-2 w-50">
              <TagCustom size={'md'} price="Adresse" colorScheme="cyan" />
              <h6>Ville :</h6>
              <p className="font-bold text-black">{town} </p>
              <h6>Quartier :</h6>
              <p className="font-bold text-black">{district} </p>
            </div>
            <div className="text-xs text-muted p-2 w-50">
              <TagCustom size={'md'} price="Media" colorScheme="cyan" />
              <h6>Cv :</h6>
              <a
                href="https://google.com/cv.pdf"
                className="font-bold text-info"
              >
                {some_document}{' '}
              </a>
              <h6>Cni :</h6>
              <a
                href="https://google.com/cv.pdf"
                className="font-bold text-info"
              >
                lien cni{' '}
              </a>
            </div>
          </div>

          <div className="flex text-xs justify-content-right align-items-center">
            <h3 className="text-black font-bold">CodeID :</h3>
            <p>123cf</p>
          </div>
          <div className="flex gap-2 mx-auto justify-content-center">
            <button className="btn btn-light font-bold bg-gray-200 text-sm btn-sm">
Assigner            </button>
            <button className="btn btn-danger font-bold bg-red0 text-white text-sm btn-sm">
              Retirer
            </button>
          </div>
        </div>

        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Modifier un profil</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <form class="w-full max-w-sm">
                <div class="md:flex md:items-center mb-6">
                  <div class="md:w-1/3">
                    <label
                      class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                      for="inline-full-name"
                    >
                      Nom{' '}
                    </label>
                  </div>
                  </div>
              </form>
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    </div>
  )
}
